// extracted by mini-css-extract-plugin
export default {"inner_loader_con":"style_inner_loader_con__gDSQr","blink":"style_blink__5JqEw","dot":"style_dot__IkD0l"};